(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairExhibitorsController', PhysicalFairExhibitorsController)

    PhysicalFairExhibitorsController.$inject = ['$uibModal', 'SellerService', 'AdmService' ,'ExpoService', 'CitiesByExpoService', 'PhysicalFairService', 'CountriesNewService','ExhibitorsService'];

    function PhysicalFairExhibitorsController($uibModal, SellerService, AdmService, ExpoService, CitiesByExpoService, PhysicalFairService, CountriesNewService, ExhibitorsService) {
        var vm = this;
        vm.exhibitors            = '';
        vm.queryFlag             = false;
        vm.exhibitorName         = '';
        vm.country               = '';
        vm.countrySelected       = '';
        vm.expo                  = '';
        vm.expoSelected          = '';
        vm.citySelected          = '';
        vm.city                  = '';
        vm.seller                = '';
        vm.sellerSelected        = '';
        vm.active                = [{name:'All',value:'All'}, {name:'Yes', value:1}, {name:'No', value:0}];
        vm.activeSelected        = {name:'All', value:'All'};
        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.getSellers            = getSellers;
        vm.selectCountries       = selectCountries;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectExpo();
            vm.selectCountries();
            vm.getSellers();
        }

        function selectCountries () {
            CountriesNewService.getCountries().then(function(response){
                vm.country = response.data;
            }).catch(function(err) {

            });
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                 vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function selectCitiesByExpo () {
            var params = [];
                params['expo_id']  = vm.expoSelected.id;
            CitiesByExpoService.getCities(params['expo_id']).then(function(response){
                    vm.city= response.data;
            }).catch(function(err) {

            });
        }

        function getSellers() {
            AdmService.getSellers().then(function(response){
                vm.seller = response.data;
                if(vm.seller.length === 1 && vm.seller[0].selected === 1){
                    vm.sellerSelected = vm.seller[0];
                }
            });
            // SellerService.getAll().then(function(response){
            //     vm.seller = response.data;
            //     if(vm.seller.length === 1 && vm.seller[0].selected === 1){
            //         vm.sellerSelected = vm.seller[0];
            //     }
            // }).catch(function(err) {

            // });
        }

        function getByFilter() {
            vm.query = {};

            if(vm.exhibitorName !== '') {
                vm.query['exhibitor_name'] = vm.exhibitorName;
            }

            if(typeof vm.countrySelected !== 'undefined') {
                vm.query['country'] = vm.countrySelected.id;
            }

            if(typeof vm.citySelected.id !== 'undefined') {
                vm.query['city']   = vm.citySelected.id;
            }

            if( vm.activeSelected.name != 'All') {
                vm.query['active']   = vm.activeSelected.value;
            }

            if(typeof vm.sellerSelected.id !== 'undefined') {
                vm.query['seller']   = vm.sellerSelected.id;
            }

            if(typeof vm.expoSelected.id !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }

            vm.query['page']            = vm.page;

            ExhibitorsService.getByFilterExhibitors(vm.query).then(function(response){
                vm.exhibitors = response.data.users;
                vm.queryFlag  = true;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {

            });

        }

        activate();
    }

})();